import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'src/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';
import { Input } from 'src/components/ui/input';

type ForecastPaginatedActionsRenameSessionModalProps = {
  open: boolean;
  sessionName: string;
  isSubmitting: boolean;
  onSessionNameChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ForecastPaginatedActionsRenameSessionModal({
  open,
  sessionName,
  isSubmitting,
  onSessionNameChange,
  onConfirm,
  onCancel,
}: ForecastPaginatedActionsRenameSessionModalProps) {
  const { t } = useTranslation('forecast');

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSessionNameChange(event.target.value);
  };

  return (
    <Dialog open={open}>
      <DialogContent className='max-h-[80vh] max-w-md' closable={false}>
        <DialogHeader>
          <DialogTitle>{t('Name your new session')}</DialogTitle>
          <DialogDescription>
            {t(
              'A new empty session was created because no other open sessions were found',
            )}
          </DialogDescription>
        </DialogHeader>
        <div className='grid gap-2'>
          <span className='text-sm font-medium text-layout-foreground'>
            {t('Next session name')}
          </span>
          <Input
            value={sessionName}
            onChange={handleInputChange}
            placeholder={t('Next session name')}
            maxLength={255}
            autoFocus
          />
        </div>
        <DialogFooter className='gap-2'>
          <Button variant='outline' onClick={onCancel} disabled={isSubmitting}>
            {t('Cancel')}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isSubmitting || !sessionName.trim()}
          >
            {t('Save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
